//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Routing.Electrical.js";
import "../Routing/Routing.Electrical.ElectricalStockDevice.js";
let d=[[],[[[],"GetAssemblyDefinition",{R_:{elec_cable_definition:"Routing.Electrical.CableDefinition"}},0,0],[["part_name"],"ImportCablePart",{},1,0],[[],"GetConduitPartNumber",{R_:{conduitPartNumber:''}},0,0],[["conduitPartNumber"],"SetConduitPartNumber",{},1,0]],[]];
SPLM.Routing.Electrical.CableDevice = class extends SPLM.Routing.Electrical.ElectricalStockDevice{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Routing.Electrical.CableDevice";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;